import { useGlobalStore } from '@highlight/ipc/react'
import { AmplitudeRenderer } from '@renderer/utils/amplitude.renderer'
import { DEFAULT_MEETING_MODE, type MeetingMode } from '@shared/types/AudioNoteSettings'
import { resolveMeetingMode } from '@shared/utils/meetings'
import { useCallback } from 'react'

export const useMeetingMode = () => {
  const [storedMeetingMode, setMeetingMode] = useGlobalStore<MeetingMode>(
    'settings',
    'meetingMode',
    DEFAULT_MEETING_MODE,
  )
  const [hasTriedAutopilot, setHasTriedAutopilot] = useGlobalStore<boolean>(
    'user',
    'hasTriedAutopilotMeetingMode',
    false,
  )

  const onChangeMeetingMode = useCallback(
    (mode: MeetingMode) => {
      AmplitudeRenderer.trackSettingUpdate('Meeting Mode', mode)
      setMeetingMode(mode)
      if (mode === 'autopilot') {
        setHasTriedAutopilot(true)
      }
    },
    [setHasTriedAutopilot, setMeetingMode],
  )

  return {
    meetingMode: resolveMeetingMode(storedMeetingMode),
    setMeetingMode: onChangeMeetingMode,
    hasTriedAutopilot,
    setHasTriedAutopilot,
  }
}
